import React from 'react';
import Box from 'components/react-styled-core/Box';
import Text from 'components/react-styled-core/Text';

import Link from './Link';

const ItemLink = ({ href = '#', onClick, children, itemNo, remark }) => (
    <Box
        pb="2x" // 8px
    >
        <Box
            display="inline-block"
            verticalAlign="top"
        >
            {itemNo && (
                <Text
                    mr="1x"
                    fontWeight="bold"
                >
                    {`${itemNo}. `}
                </Text>
            )}
        </Box>
        <Box
            display="inline-block"
            verticalAlign="top"
            maxWidth={['calc(100% - 24px)', '100%']}
        >
            <Link
                display="inline"
                color="blue:80"
                _hover={{
                    color: 'red:80',
                    textDecoration: 'underline',
                }}
                _visited={{
                    color: 'blue:80',
                }}
                href={href}
                onClick={onClick}
            >
                {children}
            </Link>
        </Box>
        {remark && (
            <Text
                display="inline"
                mx="1x"
            >
                {remark}
            </Text>
        )}
    </Box>
);

export default ItemLink;
